<template>
    <cadastro-simples-list
        endpoint="tipo-requerimento"
        rota-base="/admin/tipo-requerimento"
        titulo="TIPOS DE REQUERIMENTO"
        titulo-singular="Tipo de Requerimento"
        :colunas-extras='[]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
